import MarketingEventHelpers from "../MarketingHelpers/MarketingEventHelpers";
import { sendGtmEvent } from "../definitions";

export const variationAnalyticsClickTracking = (
  variationLink: string,
  variationText: string
) => {
  sendGtmEvent({
    event: "ga4_event",
    eventName: "PDP Variations",
    eventAction: "PDP Variations Click",
    eventLabel: `${variationLink}:${variationText}`,
    eventCategory: MarketingEventHelpers.removeEmailFromUrl(
      new URL(window.location.href)
    ),
  });
};

export default variationAnalyticsClickTracking;
